module.exports = __webpack_public_path__ + "img/HC1017-164.7fc0998d.jpg";